import Button from '@mui/material/Button';
import { useAuth, usePersonalSettings } from '@tyro/api';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@tyro/core/dialog';
import { useTranslation } from '@tyro/i18n';
import { useId } from 'react';
import { useIdleTracker } from '../hooks/use-idle-tracker';

export function IdleModal() {
  const id = useId();
  const titleId = `${id}-title`;
  const descriptionId = `${id}-description`;

  const { t } = useTranslation(['common']);

  const { security_logout_inactiveTimeUntilLogoutMinutes: inactiveTime } =
    usePersonalSettings();

  const { logout } = useAuth();
  const { isIdle, countDown, resetActivity } = useIdleTracker(
    inactiveTime ?? 30,
    logout,
  );

  return (
    <Dialog
      open={isIdle}
      onClose={resetActivity}
      aria-labelledby={titleId}
      aria-describedby={descriptionId}
    >
      <DialogTitle id={titleId} onClose={resetActivity}>
        {t('common:helloAnyoneHome')}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id={descriptionId}>
          {t('common:itLooksLikeYouveBeenIdle', { count: countDown })}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={logout}>{t('common:actions.logMeOut')}</Button>
        <Button variant="soft" onClick={resetActivity}>
          {t('common:actions.stayLoggedIn')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
